import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

export interface UnipileCalendarSyncReport {
  unipileAccountId: string
  calendarName: string
  fetched: number
  created: number
  skippedExisting: number
  skippedCancelled: number
  error: string | null
}

interface UnipileCalendarSyncResponse {
  reports: UnipileCalendarSyncReport[]
}

const syncCalendar = async (): Promise<UnipileCalendarSyncResponse> => {
  const { data } = await api.post<UnipileCalendarSyncResponse>(
    '/ft_unipile/sync-calendar',
    {},
  )
  return data
}

export const useUnipileSyncCalendar = () => {
  const queryClient = useQueryClient()

  return useMutation<UnipileCalendarSyncResponse, Error, void>({
    mutationFn: syncCalendar,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['calendar-events'] })
    },
  })
}
